// api.js

import apiUrls from "../config/apiUrls";


const apiKey = 'e68b43bc-d581-4def-9231-d25c019fb16e'
const maxSessionDuration = 120 * 60 * 1000; //120 minutes in milliseconds
const environment = process.env.REACT_APP_MODE??"";

const localStorageKeys = {
  sessionData: 'sessionData',
  sessionStartTime: 'sessionStartTime',
  userData: 'userData',
};

const updateSessionTime = () => {
  localStorage.setItem('sessionStartTime', new Date().toISOString());
};

const clearSession = () => {
  localStorage.removeItem(localStorageKeys.sessionData);
  localStorage.removeItem(localStorageKeys.sessionStartTime);
  localStorage.removeItem(localStorageKeys.userData);
  localStorage.clear();
  window.location.href = '/login';
};

const checkAndRefreshSession = () => {
  const sessionData = localStorage.getItem('sessionData');
  const sessionStartTime = localStorage.getItem('sessionStartTime');

  if (sessionData && sessionStartTime) {
    const sessionStart = new Date(sessionStartTime).getTime();
    const currentTime = Date.now();

    if (currentTime - sessionStart < maxSessionDuration) {
      updateSessionTime();
      localStorage.setItem('sessionStartTime', new Date().toISOString());
      return true;
    }
  }

  clearSession();
  return false;
};


const fetchData = async <T>(apiUrl: string, signal?: AbortSignal): Promise<T> => {
  const SendOtpEndpoint = apiUrl.includes('SendOtp') || apiUrl.includes('VerifyEmail') || apiUrl.includes('GrantAccess') || apiUrl.includes('/GetPlayerNewCardDetails')
    if (SendOtpEndpoint === false)
    {
        if (!checkAndRefreshSession()) {
          throw new Error('Session expired');
        }
    }
  try {
    const staticSessionKey = environment === "production" ? 'NzE6ZWEyODFlZDkxYjBiZjliYWU1NTJhNmZiZjcxNTczMTYtYzdlYmE0ODItNjBmNC00MjNhLTkzNTAtYjY2MmE0YTQ5YjBi' : 'NzE6ZWEyODFlZDkxYjBiZjliYWU1NTJhNmZiZjcxNTczMTYtYzdlYmE0ODItNjBmNC00MjNhLTkzNTAtYjY2MmE0YTQ5YjBi'
    const sessionKey = apiUrl.includes('/GetPlayerNewCardDetails') ? staticSessionKey : localStorage.getItem('SessionKey')
    const options: RequestInit = {
      headers: { 
        'x-api-key': apiKey, 
        'Session' : sessionKey!
      },
      signal,
    };
 
    const response = await fetch(apiUrl, options);
   
    if (response.status === 401) {
      window.location.href='/logout';
      localStorage.clear()
    }
    const data = await response.json();
  
    if(data.statusCode === '404'){
      //console.log("notfound")
      window.location.href = '/notfound'
    }
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

const postData = async <T, U>(apiUrl: string, requestBody: T, isLogin: boolean = false): Promise<U> => {

 const isRegisterEndpoint = apiUrl.includes('/Register') || apiUrl.includes('/ResetPassword');
  if (!isLogin && isRegisterEndpoint === false)
  {
    if(!checkAndRefreshSession() ){
      throw new Error('Session expired');
    }
  }
  try {
      const sessionKey = localStorage.getItem('SessionKey')
      const userData = localStorage.getItem('userData');

      const parsedUserData = userData ? JSON.parse(userData) : {};

     const requestBodyData = isRegisterEndpoint ? requestBody : { ...requestBody, userId: parsedUserData };
      const options: RequestInit = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
          'Session' : sessionKey! 
        },
        body: JSON.stringify(requestBodyData),
      };
      const response = await fetch(apiUrl, options);
      if (response.status === 401) {
        window.location.href='/logout';
        localStorage.clear()
      }
      const data = await response.json();
      if(data.statusCode === '404'){
      //console.log("notfound")
        window.location.href = '/notfound'
      }
      return data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
};

export { fetchData, postData };
